import React from 'react';

// Images where the WebP twin compressed LARGER than the original (typically small/simple
// graphics or logos with broad transparency). For these we skip the WebP <source> so the
// browser doesn't waste a request fetching a heavier file or 404'ing on a missing twin.
const NO_WEBP = new Set([
  '/images/whim_ales.png',
  '/images/thornsett_brew.png',
  '/images/glossop_rt_logo.png',
  '/images/glossop_rt_logo_alt.png',
]);

/**
 * Renders a <picture> element with a WebP source and the original image as fallback.
 * Pass the original src (e.g. "/images/hero.jpg") — the WebP twin must exist next to it
 * with the same basename ("/images/hero.webp"), which is generated at build/asset time.
 */
export default function Picture({ src, alt, className, loading = 'lazy', decoding = 'async', ...rest }) {
  const skipWebp = NO_WEBP.has(src);
  const webpSrc = skipWebp ? null : src.replace(/\.(jpe?g|png)$/i, '.webp');
  return (
    <picture>
      {webpSrc && <source srcSet={webpSrc} type="image/webp" />}
      <img
        src={src}
        alt={alt}
        loading={loading}
        decoding={decoding}
        className={className}
        {...rest}
      />
    </picture>
  );
}
